import React, { Component } from "react";
import "./gainloss-transaction-screen-audit-modal.css";
import "./gainloss-transaction-screen-common-modal.css";
import { inject, observer } from "mobx-react";
import { Form, Modal, Button } from "react-bootstrap";

const RenderRow = (props) => {
  const rows = props.fieldNames.map((col, index) => {
    const row = (
      <td key={index} className="SystemVarianceAudit">
        {col === "District"
          ? props.district.value
          : col === "LastSavedDateTime"
          ? new Date(props.data[col]).toLocaleString("en-US", {
              timeZone: "America/Denver",
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
              hour12: true,
              hour: "2-digit",
              minute: "2-digit",
            })
          : [
              "ShowFieldVarianceReport",
              "ShowFieldVarianceExplanationReport",
              "ShowSeniorManagementReport",
              "ShowFinancialReport",
            ].includes(col)
          ? props.data[col] === true
            ? "Yes"
            : "No"
          : props.data[col]}
      </td>
    );
    return row;
  });
  return rows;
};

@inject("CommonStore", "GainLossSystemVarianceDataStore")
@observer
class AuditModal extends Component {
  render() {
    return (
      <div style={{ zIndex: 1000 }}>
        <div className="modal-container" style={{ height: 250 }}>
          <Modal
            className="system-variance-audit-modal"
            show={this.props.GainLossSystemVarianceDataStore.showAuditPopUp}
            onHide={() => {}}
            size="xl"
            centered
          >
            <Form>
              <Modal.Title>Audit History</Modal.Title>
              <Modal.Body>
                <div style={{ margin: "30px", marginTop: "30px" }}>
                  {this.props.GainLossSystemVarianceDataStore.headerNames
                    .length > 0 && (
                    <div
                      className="audit-table-container"
                      style={{
                        width: "100%",
                        height: "275px",
                        overflow: "scroll",
                      }}
                    >
                      <table id="tableHeader">
                        <tbody>
                          <tr>{this.renderTableHeader()}</tr>
                          {this.renderTableData()}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.GainLossSystemVarianceDataStore.showAuditPopUp = false;
                  }}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }

  renderTableHeader() {
    return this.props.GainLossSystemVarianceDataStore.headerNames.map(
      (col, index) => {
        return (
          <th
            key={index}
            style={{
              width: col === "FieldVarianceExplanationCommnet" ? "1600px" : "",
            }}
          >
            {col}
          </th>
        );
      }
    );
  }

  renderTableData = () => {
    const data = this.props.GainLossSystemVarianceDataStore.auditData.sort(
      (a, b) =>
        a.SystemVarianceAuditId > b.SystemVarianceAuditId
          ? -1
          : b.SystemVarianceAuditId > a.SystemVarianceAuditId
          ? 1
          : 0
    );

    return data.map((auditRow, index) => {
      return (
        <tr key={index}>
          <RenderRow
            data={auditRow}
            fieldNames={this.props.GainLossSystemVarianceDataStore.fieldNames}
            district={this.props.GainLossSystemVarianceDataStore.district}
          />
        </tr>
      );
    });
  };
}
export default AuditModal;
